import {BoxProps, Button, Grid, Paper} from "@mui/material";
import {useQuery} from "react-query";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";
import axiosClient from "../../../../../../lib/axios";
import {IDetalharAgrotoxico} from "../../../../../../types/api/receituarioAgronomico/detalhar-agrotoxico";
import {ConfirmProvider} from "material-ui-confirm";
import React from "react";
import CardDadosAgrotoxico from "./CardDadosAgrotoxico";
import CardDadosRelacionamentos, {TRelacionamento} from "./CardDadosRelacionamentos";

export default function DialogDetalheAgrotoxico({
                                                    open,
                                                    value,
                                                    handleClose
                                                }: DialogDetalheAgrotoxicoProps) {

    // Queries and mutations
    const {data, isLoading} = useQuery({
        queryKey: [`detalhar-agrotoxico/${value}`, value],
        queryFn: () => axiosClient.get(`/receituario-agronomico/agrotoxicos/detalhar-agrotoxico`, {
            params: {id: value}
        }),
        cacheTime: 0
    });
    const detalhe: TDataQuery = data?.data || null;
    const boxStyle: BoxProps = {component: Paper, p: 2, display: "flex", flexDirection: "column", gap: 3}

    return (
        <DialogFullScreen
            {...{open, handleClose}}
            title="Detalhe do agrotóxico"
        >
            {isLoading && <LoadingApiQuery/>}

            {
                (!isLoading && detalhe) &&
                <>
                    <Grid container spacing={2}>
                        <Grid container size={{xs: 12, md: 12}} spacing={2} alignSelf="flex-start">
                            <Grid size={{xs: 12}}>
                                <ConfirmProvider defaultOptions={{
                                    title: 'Excluir item',
                                    cancellationText: "Cancelar",
                                    confirmationText: "Excluir",
                                    confirmationButtonProps: {variant: 'contained', color: 'error'}
                                }}>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                    >
                                        Excluir
                                    </Button>
                                </ConfirmProvider>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <CardDadosAgrotoxico
                                    {...{boxStyle, detalhe}}
                                    codigo={value}/>
                            </Grid>
                            <Grid size={{xs: 12}}>

                                <CardDadosRelacionamentos
                                    {...{boxStyle, detalhe}}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            }

        </DialogFullScreen>
    );
}

interface DialogDetalheAgrotoxicoProps {
    open: boolean;
    handleClose: () => void;
    value: string;
}

type TDataQuery = IDetalharAgrotoxico & {
    relacionamentos: TRelacionamento[];
} | null;